<template>
  <div class="d-flex justify-center">
    <v-btn :outlined="status !== 'attendance'" class="mr-2" color="success" @click="onAttend"> Có mặt </v-btn>
    <v-btn :outlined="status !== 'absent'" color="warning" @click="onAbsent"> Vắng mặt </v-btn>
    <div v-if="status === 'absent'" class="ml-2">
      <v-btn :outlined="subStatus !== 'excused'" class="mr-2" color="success" @click="onExcused"> Có phép </v-btn>
      <v-btn :outlined="subStatus !== 'unexcused'" color="warning" @click="onUnexcused"> Không phép </v-btn>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  props: {
    srcStatus: String,
    srcSubStatus: String,
    id: String,
  },
  data: () => ({ status: '', subStatus: '' }),
  methods: {
    ...mapMutations('boardingClassSessionAttendance', ['addToAbsents', 'removeFromAbsents', 'markAbsentExcused', 'markAbsentUnexcused']),
    onAttend() {
      this.status = 'attendance'
      this.removeFromAbsents(this.id)
    },
    onAbsent() {
      this.status = 'absent'
      this.addToAbsents(this.id)
    },
    onExcused() {
      this.subStatus = 'excused'
      this.markAbsentExcused(this.id)
    },
    onUnexcused() {
      this.subStatus = 'unexcused'
      this.markAbsentUnexcused(this.id)
    }
  },
  watch: {
    srcStatus: {
      handler(val) {
        this.status = val
      },
      immediate: true,
    },
    srcSubStatus: {
      handler(val) {
        this.subStatus = val
      },
      immediate: true,
    }
  },
}
</script>